import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { AgencySecurityComponent } from './components/agency-security/agency-security.component';
import { SiteSecurityComponent } from './components/site-security/site-security.component';


const routes: Routes = [
  { path: '', redirectTo: '/agency-admin', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'agency-admin', component: AgencySecurityComponent, canActivate: [AuthGuardService], data: { siteAdmin: true, agencyAdmin: true } },
  { path: 'site-admin', component: SiteSecurityComponent, canActivate: [AuthGuardService], data: { siteAdmin: true } },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

export const routingComponents = [
  PageNotFoundComponent,
  LoginComponent,
  LogoutComponent,
  AgencySecurityComponent,
  SiteSecurityComponent
];
